let cognitoconfig = {};
if (process.env.NODE_ENV === "production") {
  cognitoconfig = {
    aws_project_region: "eu-west-1",
    aws_cognito_region: "eu-west-1",
    aws_user_pools_id: "eu-west-1_6ULRshV8Q",
    aws_user_pools_web_client_id: "6np00olr1gc24sh0hag8co2rti",
  };
} else {
  cognitoconfig = {
    aws_project_region: "eu-west-1",
    aws_cognito_region: "eu-west-1",
    aws_user_pools_id: "eu-west-1_6ULRshV8Q",
    aws_user_pools_web_client_id: "6np00olr1gc24sh0hag8co2rti",
  };
}

export default cognitoconfig;
